'use strict';
import angular from 'angular';

angular.module('currentUser.services')
    .factory('CurrentUserServerGateway', ['IORestangular', function (IORestangular) {
        return {
            getLoggedInUser: function () {
                return IORestangular.one('users/loggedInUser').get();
            }
        };
    }]);